import script from "./Assets.vue?vue&type=script&lang=ts&setup=true"
export * from "./Assets.vue?vue&type=script&lang=ts&setup=true"

import "./Assets.vue?vue&type=style&index=0&id=d0ff3a6e&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0ff3a6e"]])

export default __exports__